import { FunctionComponent } from 'react'
import ReactModal from 'react-modal'
import Button from '../Button/Button'
import { zIndex } from '../../../lib/zIndex'
import './Modal.css'

interface IModal {
	open: boolean
	onClose: () => void
	onOpen?: () => void
	children?: React.ReactNode
	size?: 'small' | 'large'
}

/**
 * Modal component wrapping react-modal library.
 * Ensures modal overlay (darkened background) always renders above page content,
 * including sticky headers. The overlay uses z-50 (MODAL_OVERLAY) to guarantee
 * it appears above sticky headers (z-10). Dropdown menus (z-60) deliberately outrank this,
 * since they're always portaled to document.body and may be used as form fields inside a modal.
 * See frontend/src/lib/zIndexDocumentation.md for full stacking context explanation.
 */
const Modal: FunctionComponent<IModal> = ({ children, onOpen, onClose, open, size = 'large' }) => {
	return (
		<>
			<ReactModal
				isOpen={open}
				onAfterOpen={onOpen}
				onAfterClose={onClose}
				shouldCloseOnEsc={true}
				shouldCloseOnOverlayClick={true}
				onRequestClose={() => {
					onClose()
				}}
				className={`isumio-modal bg-charcoal-500 rounded-lg p-8 ${
					size === 'small' ? 'isumio-modal--small' : 'isumio-modal--large'
				}`}
				overlayClassName={`isumio-overlay z-${zIndex.MODAL_OVERLAY} bg-charcoal-500`}
			>
				<Button
					type='Link'
					hasTrailingIcon={true}
					icon='fa-solid fa-xmark'
					additionalClass={`isumio-closebutton z-${zIndex.MODAL_CLOSE_BUTTON}`}
					onClick={() => onClose()}
					accessibilityLabel='Close dialog'
				/>
				{children}
			</ReactModal>
		</>
	)
}

export default Modal
